import { dummyDataSource } from './demo/mock/dummy-data-source';
import {
  applyError,
  campaignBidLandscapeTrack,
  formatRes,
  getParams,
  validateSearchBid,
} from './src/bid-landscape';

export function getCampaignsGridFactory() {
  return () => import(/* webpackMode: 'eager' */ './src/new-pkg/campaigns-grid-factory'); // eslint-disable-line no-unused-vars
}

export {
  applyError,
  campaignBidLandscapeTrack,
  dummyDataSource,
  formatRes,
  getParams,
  validateSearchBid,
};
